// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/shinri/AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ShogiPlayer .DebugBlock{font-size:.75rem;word-break:break-all}.ShogiPlayer .DebugBlock caption{font-weight:700}.ShogiPlayer .DebugBlock thead th:first-of-type,.ShogiPlayer .DebugBlock thead th:nth-of-type(3){width:25%}", ""]);
// Exports
module.exports = exports;
